import clsx from 'clsx';
import { TfNotification, useUpdateNotifications } from 'api';
import mixpanel from 'mixpanel-browser';
import { NotificationTypeEnum } from 'oas';
import * as React from 'react';
import {
    ActivityOwnership,
    Info,
    NewDownload,
    NewMaxHr,
    NewMaxVel,
    NewMaxMechanicalPower,
    NotificationTypeProps,
    PasswordExpiring,
    Welcome,
    DataSharing,
} from './types';
import styles from './notifications-drawer.module.css';

interface NotificationListItemProps {
    notification: TfNotification;
}

const COMPONENTS: Partial<Record<string, React.ComponentType<NotificationTypeProps>>> = {
    [NotificationTypeEnum.ActivityOwnership]: ActivityOwnership,
    [NotificationTypeEnum.PasswordExpiring]: PasswordExpiring,
    [NotificationTypeEnum.NewMaxVel]: NewMaxVel,
    [NotificationTypeEnum.NewMaxHr]: NewMaxHr,
    [NotificationTypeEnum.NewMaxMechanicalPower]: NewMaxMechanicalPower,
    [NotificationTypeEnum.Info]: Info,
    [NotificationTypeEnum.Welcome]: Welcome,
    [NotificationTypeEnum.NewDownload]: NewDownload,
};

export const NotificationListItem: React.FC<NotificationListItemProps> = ({ notification }) => {
    const updateNotification = useUpdateNotifications();
    const NotificationComponent = notification.type.includes('ds_') ? DataSharing : COMPONENTS[notification.type];

    function handleToggleRead() {
        const isRead = !notification.read;
        updateNotification.mutate({ ids: [notification.id], read: isRead });
        mixpanel.track(isRead ? 'BellNotificationMarkRead' : 'BellNotificationMarkUnread', { type: notification.type });
    }

    return NotificationComponent ? (
        <div className={clsx(styles['item'], { [styles['deleting']]: notification.isDeleting })}>
            <div>
                <div className={styles['item-inner']}>
                    <NotificationComponent notification={notification} handleToggleRead={handleToggleRead} />
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
};
